<template>
  <div v-if="searchColumns && searchColumns.length"
       class="data-grid-search-filter">
    <slot :toggle-visible="toggleVisible"></slot>
    <DataGridDialog :visible.sync="visible"
                    title="搜索列配置"
                    width="360px"
                    custom-class="data-grid-search-filter-dialog">
      <div class="body">
        <AppScrollbar style="height: 260px">
          <div class="filter-wrap">
            <el-checkbox-group v-model="filterColumns">
              <div v-for="(column, index) in searchColumns"
                   :key="'search_column_' + index"
                   class="filter-item">
                <el-checkbox :label="column.prop">{{column.name}}</el-checkbox>
              </div>
            </el-checkbox-group>
          </div>
        </AppScrollbar>
      </div>
      <div class="footer">
        <el-button size="mini"
                   type="primary"
                   @click="handleApply">保存设置</el-button>
        <el-button size="mini"
                   type="default"
                   @click="handleClose">取消设置</el-button>
      </div>
    </DataGridDialog>
  </div>
</template>

<script>
import DataGridDialog from './DataGridDialog'
import AppScrollbar from '../AppScrollbar'
export default {
  name: 'DataGridSearchFilter',
  components: {
    DataGridDialog,
    AppScrollbar
  },
  props: {
    searchColumns: {
      type: Array
    },
    searchFilter: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      visible: false,
      filterColumns: []
    }
  },
  methods: {
    toggleVisible () {
      this.visible = !this.visible
    },
    handleClose () {
      this.visible = false
    },
    handleApply () {
      const searchFilter = {}
      const searchColumns = this.searchColumns
      if (searchColumns) {
        searchColumns.forEach(column => {
          searchFilter[column.prop] = this.filterColumns.includes(column.prop)
        })
      }
      this.$emit('filter-change', searchFilter)
      this.$nextTick(() => this.handleClose())
    }
  },
  watch: {
    visible (val) {
      if (val) {
        this.filterColumns = (this.searchColumns || []).filter(column => !!this.searchFilter[column.prop])
          .map(column => column.prop)
      }
    }
  }
}
</script>

<style lang="scss">
  .data-grid-search-filter {
    display: inline-block;
  }
  .data-grid-search-filter-dialog {
    &>.el-dialog__body {
      .body {
        .filter-wrap {
          padding: 8px 15px;
          .filter-item {
            .el-checkbox {
              .el-checkbox__label {
                font-size: 13px;
              }
            }
            &+.filter-item {
              margin-top: 3px;
            }
          }
        }
      }
      .footer {
        height: 52px;
        background-color: #fff;
        border-top: 1px solid rgba(0,0,0,.05);
        text-align: center;
        line-height: 50px;
      }
    }
  }
</style>
